import { Box, Typography, IconButton } from "@mui/material"
import { Language } from "@mui/icons-material"

interface BrokerWebButtonProps {
  pageUrl: string
  facebookNick?: string | null
  instagramNick?: string | null
  linkedinNick?: string | null
  xNick?: string | null
  onViewProfile: () => void
}

const BrokerWebButton = ({
  pageUrl,
  facebookNick,
  instagramNick,
  linkedinNick,
  xNick,
  onViewProfile,
}: BrokerWebButtonProps) => {
  // Función para abrir URLs de manera segura
  const openUrl = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer")
  }

  // Filtrar redes sociales disponibles
  const socialNetworks = [
    {
      nick: facebookNick,
      href: facebookNick ? `https://facebook.com/${facebookNick}` : "",
      bg: "#1877F2",
      icon: "/assets/images/facebook-icon.png",
      alt: "Facebook",
      shadow: "rgba(24, 119, 242, 0.4)",
    },
    {
      nick: instagramNick,
      href: instagramNick ? `https://instagram.com/${instagramNick}` : "",
      bg: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
      icon: "/assets/images/insta-icon.png",
      alt: "Instagram",
      shadow: "rgba(220, 39, 67, 0.4)",
    },
    {
      nick: linkedinNick,
      href: linkedinNick ? `https://linkedin.com/in/${linkedinNick}` : "",
      bg: "#0A66C2",
      icon: "/assets/images/linkedin-icon.png",
      alt: "LinkedIn",
      shadow: "rgba(10, 102, 194, 0.4)",
    },
    {
      nick: xNick,
      href: xNick ? `https://twitter.com/${xNick}` : "",
      bg: "#000000",
      icon: "/assets/images/x-icon.png",
      alt: "X",
      shadow: "rgba(0, 0, 0, 0.4)",
    },
  ].filter((item) => item.nick)

  return (
    <>
      <Box
        sx={{
          mt: 2,
          p: 2,
          borderRadius: "12px",
          border: "1px solid #2196F3",
          backgroundColor: "rgba(33, 150, 243, 0.05)",
        }}
      >
        {/* Web del broker */}
        <Box
          onClick={() =>
            openUrl(`https://alienrealtybrokers-dkfthae6gjh6b9cd.canadacentral-01.azurewebsites.net/${pageUrl}`)
          }
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "8px",
            px: 1,
            py: 0.5,
            width: "100%",
          }}
        >
          <Language sx={{ color: "#2196F3", fontSize: 24, mr: 2 }} />
          <Box>
            <Typography variant="caption" sx={{ color: "#757575", display: "block", fontSize: "0.7rem" }}>
              Ir a la página web del broker
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#2196F3",
                fontWeight: "medium",
                textDecoration: "underline",
              }}
            >
              {pageUrl}
            </Typography>
          </Box>
        </Box>
      </Box>

      {socialNetworks.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 3,
            mt: 3,
            mx: "auto",
            width: "100%",
            textAlign: "center",
          }}
        >
          {socialNetworks.map(({ href, icon, alt }, i) => (
            <Box
              key={i}
              sx={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconButton
                onClick={() => openUrl(href)}
                sx={{
                  color: "white",
                  borderRadius: "50%",
                  padding: 0,
                  width: 40,
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={icon || "/placeholder.svg"}
                  alt={alt}
                  width={24}
                  height={24}
                  style={{ objectFit: "contain" }}
                />
              </IconButton>
            </Box>
          ))}
        </Box>
      )}
    </>
  )
}

export default BrokerWebButton
